import { FC } from 'react';

import { BugoRouter } from '@route/BugoRouters/BugoRouter';
import { GiftStoreRouter } from '@route/GiftStoreRouters/GiftStoreRouter';
import {
  AdminRouterLazy,
  GiftApiRouterLazy,
  GiftBrandRouterLazy,
  GiftSellerRouterLazy,
  KakaoCallbackPageLazy,
  SellerRouterLazy,
} from '@route/lazyRouters';
import { StoreRouter } from '@route/StoreRouters/StoreRouter';
import { lazyRoute } from '@shared/components/RouteFallback';
import { Route, Routes } from 'react-router-dom';

//* 조문객 기본 번들에는 BugoRouter + 구매 퍼널(화환·답례품 스토어)을 싣고, 나머지 영역은 진입 시 청크로 받는다(@route/lazyRouters).
//*
//! Suspense는 라우트마다 따로 둔다 — 전체 <Routes>를 하나로 감싸면 안 된다.
//! 하나로 감싸면 lazy 청크를 처음 받는 동안 React가 "이미 그려진 쪽"(부고장 트리)을 display:none으로
//! 숨기고 폴백을 띄우는데, headlessui Dialog는 자기 요소가 화면에서 사라지면(IntersectionObserver 크기 0)
//! onClose를 스스로 부른다. 그 onClose가 history.back()이라 방금 push된 체크아웃 항목이 pop돼
//! "간편구매 모달에서 주문하기를 처음 누르면 모달만 닫히고 부고장에 머문다"(2026-11-02 실사고,
//! 두 번째부터는 청크가 캐시돼 재현 안 됨). 라우트별 Suspense면 부고장 트리는 즉시 정상 언마운트되고
//! 폴백은 새 라우트 자리에만 뜬다. 회귀 테스트: src/__adhoc__/lazyRouteSuspense.adhoc.test.tsx

export const AppRoutes: FC = function AppRoutes() {
  return (
    <Routes>
      <Route path="*" element={<BugoRouter />} />
      {/* 구매 퍼널은 청크 분리 없이 기본 번들 — 사유는 lazyRouters.ts 상단 */}
      <Route path="flower-store/*" element={<StoreRouter />} />
      <Route path="gift-store/*" element={<GiftStoreRouter />} />
      <Route path="flower-seller/*" element={lazyRoute(<SellerRouterLazy />)} />
      <Route path="gift-seller/*" element={lazyRoute(<GiftSellerRouterLazy />)} />
      <Route path="gift-brand/*" element={lazyRoute(<GiftBrandRouterLazy />)} />
      <Route path="admin/*" element={lazyRoute(<AdminRouterLazy />)} />
      <Route path="gift-api/*" element={lazyRoute(<GiftApiRouterLazy />)} />
      <Route path="social/kakao/auth" element={lazyRoute(<KakaoCallbackPageLazy />)} />
    </Routes>
  );
};
